import { observer } from "mobx-react-lite";
import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Container, Row } from "reactstrap";
import { RootStoreContext } from "../app/stores/rootStore";
import GenericBrowsePageResizeHelper from "../components/common/GenericBrowsePageResizeHelper";
import Loader from "../components/common/Loader";
import GenericTeletabberGallery from "../components/gallery/GenericTeletabberGallery";
import GuestNavbar from "../components/guest/GuestNavbar";
import TitleNavbar from "../components/navbars/TitleNavbar";
import ToolbarSelector from "../components/navbars/ToolbarSelector";

interface IParams {
  zone: string;
}

const GuestBrowsePage: React.FC<IParams> = ({ zone }) => {
  const rootStore = useContext(RootStoreContext);
  const { currentBrowsePageContent, resetBrowsePage } = rootStore.commonStore;
  const { destroyZwibblerContext } = rootStore.zwibblerStore;
console.log("GuestBrowsePage")
  useEffect(() => {
    return () => {
      resetBrowsePage();
      destroyZwibblerContext();
    };
  }, [resetBrowsePage, destroyZwibblerContext]);

  if (!currentBrowsePageContent) return <Loader />;

  return (
    <>
      <GuestNavbar />
      <Container fluid>
        <GenericBrowsePageResizeHelper />
        <Row>
          <TitleNavbar title={currentBrowsePageContent.title.document} />
        </Row>
        <Row>
          <ToolbarSelector
            items={currentBrowsePageContent.items}
            isSidebarOpen={false}
            stickyButton="onair"
          />
        </Row>
        <Row>
          <GenericTeletabberGallery
            items={currentBrowsePageContent.items}
            startingPage={0}
          />
        </Row>
      </Container>
    </>
  );
};

export default observer(GuestBrowsePage);
